import MasterGroupArrayField from './MasterGroupArrayField';

export default MasterGroupArrayField;
